/* RESPONSIBLE TEAM: team-rd-services */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { type Router } from '@ember/routing';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAiAgentAnalyzeMonitorRoute extends Route {
  @service declare appService: AppService;
  @service declare router: Router;

  queryParams = {
    interval: { refreshModel: false },
  };

  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.analyze.monitor',
  };

  reactEnabled() {
    return true;
  }

  async beforeModel() {
    if (!this.appService.app.canSeeMonitor) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.analyze.performance');
    }
  }
}

export default ReactRoute(AutomationFinAiAgentAnalyzeMonitorRoute, {
  overrideRenderTemplate: false,
});
